module.exports = __webpack_public_path__ + "static/media/AvatarRajendra.994885b3.png";